export enum FlagType {
  main = 'main',
  news = 'news',
  price = 'price',
  featured = 'featured',
  delivery = 'delivery',
  arbitrary = 'arbitrary',
  buybuttoninactive = 'buybuttoninactive',
  favorite = 'favorite',
  outlet = 'outlet',
}

export enum EntityType {
  configuration = 'configuration',
  article = 'article',
}

export enum LimitType {
  Date = 'Date',
  Stock = 'Stock',
}
